const cleanUnicodeCharacters = (text)=>text.replace(/[\u0000-\u001F\u007F-\u009F\u200B-\u200D\uFEFF\u2028-\u2029\u200E-\u200F]/g, '').replace(/[\u00A0\u1680\u180E\u2000-\u200A\u202F\u205F\u3000]/g, ' ').replace(/\u00AD/g, '\n').normalize('NFKC');
export { cleanUnicodeCharacters };
